import React from 'react'

import ErrorBoundary from '@/utils/ErrorBoundary'

import { MotionProvider } from './design/MotionProvider'
import { ThemeProvider } from './design/ThemeProvider'
import Home from './routes/Home'
import { FirebaseProvider } from './store/FirebaseProvider'

export const App = () => (
  <FirebaseProvider>
    <MotionProvider>
      <ThemeProvider>
        <ErrorBoundary>
          <Home />
        </ErrorBoundary>
      </ThemeProvider>
    </MotionProvider>
  </FirebaseProvider>
)

export default App
